/**
 * The `photosDate` URL param's format: a single local calendar day, `YYYY-MM-DD`.
 *
 * Shared so whoever builds a photo-viewer link and the viewer that reads it can never drift apart —
 * the viewer compares this string exactly.
 */
export const getLocalCalendarDate = (timestamp: number): string => {
  const date = new Date(timestamp);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

/** Normalizes any parseable date string to `getLocalCalendarDate`'s format. */
export const parseCalendarDate = (dateString: string): string | undefined => {
  const parsed = new Date(dateString);
  if (isNaN(parsed.getTime())) return undefined;
  return getLocalCalendarDate(parsed.getTime());
};
